import { YStack, XStack, Text, Button, Image, View, Circle } from "tamagui";
import gasStationImg from "@styles/images/gasStation.png";
import { RiPhoneLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { colors } from "@styles/colors";
import { IdentitySupplier } from "@utils/store/user/useUser";

const GasStationCard = ({ data }: { data: IdentitySupplier }) => {
  const navigate = useNavigate();
  return (
    <YStack
      bg={colors.light}
      br={16}
      borderWidth={1}
      borderColor={colors.gray100}
      shadowColor="rgba(0,0,0,0.06)"
      shadowRadius={12}
      shadowOffset={{ width: 0, height: 4 }}
      overflow="hidden"
      my="$2.5"
      animation="quick"
      pressStyle={{ scale: 0.98 }}>
      <View position="relative" height={160}>
        <Image source={{ uri: gasStationImg, height: 160 }} width="100%" objectFit="cover" />
      </View>
      <YStack p="$3.5" pt="$4" gap="$3">
        <XStack jc="space-between" ai="flex-start">
          <YStack>
            <Text fontSize={16} fontWeight="800" color={colors.grayDark}>
              {data?.supplier_name || "瓦斯行"}
            </Text>
            <XStack space="$2" mt="$1.5" ai="center">
              <XStack ai="center" space="$1">
                <RiPhoneLine size={14} color={colors.gray200} />
                <Text fontSize={13} color={colors.gray200} fow="500">
                  {data?.phone || "-"}
                </Text>
              </XStack>
            </XStack>
          </YStack>
          {data?.is_open_now && (
            <XStack ai="center" gap="$1.5" bg={colors.bgGreen} px="$2" py="$1" br={12}>
              <Circle size={8} bg={colors.green} />
              <Text color={colors.green} fontSize={12} fow="700">
                營業中
              </Text>
            </XStack>
          )}
        </XStack>
        <XStack space="$2" mt="$1">
          <Button
            f={1}
            h={44}
            fontSize={15}
            fontWeight="700"
            bg={colors.primary}
            color="white"
            br={12}
            pressStyle={{ opacity: 0.8 }}
            onPress={() => {
              const params = new URLSearchParams({ supplierId: data?.supplier_id });
              navigate(`/gasShop/products?${params.toString()}`);
            }}>
            立即訂購
          </Button>
        </XStack>
      </YStack>
    </YStack>
  );
};

export const GasStationList = ({ list }: { list: IdentitySupplier[] }) => {
  return (
    <YStack>
      {list?.length > 0 && list.map((item: IdentitySupplier) => <GasStationCard key={item.supplier_id} data={item} />)}
    </YStack>
  );
};

export default GasStationList;
